import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgSearch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m66.335 60.663 32.604 26.87a7.053 7.053 0 0 1 .73 10.226c-2.74 2.994-7.449 3.136-10.367.311L58.974 68.712l7.36-8.049Z"
        fill="#007A5F"
      />
      <path d="m76.682 69.08.973 17.529-18.68-17.923 7.402-8.023 10.305 8.418Z" fill="#00664F" />
      <path
        d="m76.682 69.08.973 17.529-18.68-17.923 7.402-8.023 10.305 8.417Zm-16.308-.437 16.141 15.486-.807-14.553-9.236-7.543-6.098 6.61Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.601 77.126C49.14 84.569 66.956 78.817 74.4 64.28c7.443-14.536 1.692-32.355-12.846-39.798-14.537-7.442-32.355-1.691-39.797 12.846-7.443 14.537-1.692 32.355 12.845 39.798Z"
        fill="#78B441"
      />
      <path
        d="M69.353 50.804c0 11.75-9.526 21.275-21.275 21.275-11.75 0-21.276-9.525-21.276-21.275 0-11.75 9.526-21.275 21.276-21.275s21.275 9.525 21.275 21.275Z"
        fill="#E6F4F0"
      />
      <path
        d="M30.154 50.285c0-9.612 7.792-17.404 17.404-17.404a.8.8 0 1 1 0 1.6c-8.728 0-15.804 7.075-15.805 15.804a.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M26.003 50.805c0-12.173 9.632-22.075 21.555-22.075a.8.8 0 1 1 0 1.6c-11.002 0-19.956 9.148-19.956 20.475 0 11.326 8.954 20.474 19.956 20.474a.8.8 0 0 1 0 1.6c-11.923 0-21.555-9.902-21.555-22.074ZM84.392 17.51a.8.8 0 0 1 1.054 1.206l-8.303 7.264a.8.8 0 1 1-1.052-1.204l8.301-7.265ZM85.704 29.808a.8.8 0 0 1 .506 1.518l-6.227 2.076a.8.8 0 0 1-.506-1.519l6.227-2.075ZM70.685 14.703a.8.8 0 0 1 1.486.594l-2.076 5.19a.8.8 0 0 1-1.486-.595l2.076-5.189Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgSearch)
